import { Injectable } from '@angular/core';
import { filter, Observable, switchMap, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Credential, Local } from '@models/.';
import { environment } from '@environments/environment';
import { ResponseSuccess } from '@interfaces/response-success';
import { AuthenticationState } from '@store/reducers/authentication.reducer';
import { selectCredential } from '@store/selectors/authentication.selectors';

@Injectable({
  providedIn: 'root',
})
export class LocalesService {
  credential$: Observable<Credential | null>;

  constructor(
    private http: HttpClient,
    private store: Store<AuthenticationState>
  ) {
    this.credential$ = this.store.select(selectCredential);
  }

  getLocal(id: string): Observable<ResponseSuccess<Local>> {
    return this.credential$.pipe(
      filter((credential) => !!credential?.granted),
      take(1),
      switchMap((credential) => {
        const token =
          credential && credential?.token
            ? credential.token
            : credential?.apiKey
              ? credential?.apiKey
              : '';

        return this.http.get<ResponseSuccess<Local>>(
          `${environment.microConfiguraciones}/api/v1/locales/${id}`,
          { headers: { Authorization: token } }
        );
      })
    );
  }

  getLocals(): Observable<ResponseSuccess<Local>> {
    return this.credential$.pipe(
      filter((credential) => !!credential?.granted),
      take(1),
      switchMap((credential) => {
        const token =
          credential && credential?.token
            ? credential.token
            : credential?.apiKey
              ? credential?.apiKey
              : '';

        return this.http.get<ResponseSuccess<Local>>(
          `${environment.microConfiguraciones}/api/v1/locales`,
          {
            headers: { Authorization: token },
            params: {
              localId: credential!.idTienda!,
            }
          },
        );
      })
    );
  }
}
